/**
 * @generated SignedSource<<e6a1a91d8dc944329e121d857733d6be>>
 * @relayHash 1e6bcc98dd35ec6eaeb74632645b2d13
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 827fd8b06471c896a386a75971cfc509f66d7643e7d62f44335d91fa45b2e8f5

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraAddIssuesToFixVersionInput = {
  issueIds: ReadonlyArray<string>;
  versionId: string;
};
export type useAddIssuesToVersionMutation$variables = {
  boardId: string;
  input: JiraAddIssuesToFixVersionInput;
};
export type useAddIssuesToVersionMutation$data = {
  readonly jira: {
    readonly addIssuesToFixVersion: {
      readonly success: boolean;
      readonly version: {
        readonly " $fragmentSpreads": FragmentRefs<"versionCard_softwareVersionBacklogPanelRelay_jiraVersionFragment">;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useAddIssuesToVersionMutation = {
  response: useAddIssuesToVersionMutation$data;
  variables: useAddIssuesToVersionMutation$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcvisualrefresheap2relayprovider": isVisualRefreshEAPEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcismanageversionspermissionenabledrelayprovider": isManageVersionsPermissionEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcismanageversionspermissionenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcvisualrefresheap2relayprovider: {
    readonly get: () => boolean;
  };
});

import isManageVersionsPermissionEnabled_provider from '@atlassian/jira-relay-provider/src/is-manage-versions-permission-enabled.relayprovider';
import isVisualRefreshEAPEnabled_provider from '@atlassian/jira-relay-provider/src/visual-refresh-eap-2.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "boardId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "success"
},
v4 = {
  "kind": "ScalarField",
  "name": "name"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = [
  {
    "kind": "ScalarField",
    "name": "canPerform"
  }
],
v7 = [
  {
    "alias": "editProjectConfig",
    "args": [
      {
        "kind": "Literal",
        "name": "type",
        "value": "EDIT_PROJECT_CONFIG"
      }
    ],
    "concreteType": "JiraProjectAction",
    "kind": "LinkedField",
    "name": "action",
    "plural": false,
    "selections": (v6/*: any*/),
    "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useAddIssuesToVersionMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraAddIssuesToFixVersionPayload",
            "kind": "LinkedField",
            "name": "addIssuesToFixVersion",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "versionCard_softwareVersionBacklogPanelRelay_jiraVersionFragment"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcvisualrefresheap2relayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcismanageversionspermissionenabledrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "useAddIssuesToVersionMutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "JiraAddIssuesToFixVersionPayload",
            "kind": "LinkedField",
            "name": "addIssuesToFixVersion",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "concreteType": "JiraVersion",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "versionId"
                  },
                  (v4/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "description"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "status"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "startDate"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "releaseDate"
                  },
                  {
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "boardId",
                        "variableName": "boardId"
                      }
                    ],
                    "concreteType": "JiraVersionStatistics",
                    "kind": "LinkedField",
                    "name": "statistics",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "doneEstimate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "totalEstimate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "percentageCompleted"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "notEstimated"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "done"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "totalIssueCount"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "toDo"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "inProgress"
                      }
                    ]
                  },
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "key"
                      },
                      (v5/*: any*/),
                      {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcismanageversionspermissionenabledrelayprovider",
                        "kind": "Condition",
                        "passingValue": false,
                        "selections": (v7/*: any*/)
                      },
                      {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcismanageversionspermissionenabledrelayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": "canManageVersions",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "type",
                                "value": "MANAGE_VERSIONS"
                              }
                            ],
                            "concreteType": "JiraProjectAction",
                            "kind": "LinkedField",
                            "name": "action",
                            "plural": false,
                            "selections": (v6/*: any*/),
                            "storageKey": "action(type:\"MANAGE_VERSIONS\")"
                          }
                        ]
                      },
                      {
                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcvisualrefresheap2relayprovider",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": (v7/*: any*/)
                      }
                    ]
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__id"
                      }
                    ]
                  },
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "827fd8b06471c896a386a75971cfc509f66d7643e7d62f44335d91fa45b2e8f5",
    "metadata": {},
    "name": "useAddIssuesToVersionMutation",
    "operationKind": "mutation",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcvisualrefresheap2relayprovider": isVisualRefreshEAPEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcismanageversionspermissionenabledrelayprovider": isManageVersionsPermissionEnabled_provider
    }
  }
};
})();

(node as any).hash = "78cd3b934e90c86f1f62037be8c3d343";

export default node;
